import { Box, Typography } from "@bca/ui-library";

const SecondaryInfo: React.FunctionComponent<{
  listOfItems: string[];
}> = ({ listOfItems }) => {
  return (
    <Box
      as="ul"
      display="flex"
      alignItems="center"
      flexDirection="row"
      flexWrap="wrap"
      px="0"
      marginY={0}
      css={`
        list-style-type: none;
      `}
    >
      {listOfItems.map(
        (item, index) =>
          Boolean(item) && (
            <Box
              as="li"
              key={`${index}-${item}`}
              marginY={1}
              css={`
                & > p::after {
                  content: "•";
                  color: #374d62;
                  margin-left: 8px;
                  margin-right: 8px;
                }

                &:last-child > p::after {
                  display: none;
                }
              `}
            >
              <Typography variant="body-small" my="0" color="grey-blue">
                {item}
              </Typography>
            </Box>
          )
      )}
    </Box>
  );
};

export default SecondaryInfo;
